import { render } from "./DashboardAdmin.vue?vue&type=template&id=7360123d&scoped=true"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"

import "./DashboardAdmin.vue?vue&type=style&index=0&id=7360123d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7360123d"]])

export default __exports__